import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { injectIntl } from "react-intl";
import { useQuery, useMutation, queryCache } from "react-query";
import * as Yup from "yup";
import Alert from 'react-s-alert';
import PageLoading from "../../../components/Loading";
import { InputFloatingLabel, ImageUpload } from "../../../formik";
import ArchiveHeader from "../../../components/ArchiveHeader";
import { getSchedule, postSchedule, putSchedule } from '../schedules/xhr';
import { cleanObjectAndReturn } from "../../../helpers/cleanObject"

const TypeForm = ({ intl, match, history, locale, setLocale}) => {

  const editForm = match.params.id ? true : false;

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [postScheduleMutation] = useMutation(postSchedule, {
    onSuccess: (createdSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          types: schedule.types.concat([createdSchedule])
        }));
      }
      Alert.success(intl.formatMessage({id: 'type.create-success'}));
      history.push("/types");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })
  const addType = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.type.create_do"}));
    await postScheduleMutation({collection: 'type', schedule: cleanObjectAndReturn(values)})
  };

  const [putScheduleMutation] = useMutation(putSchedule, {
    onSuccess: (updatedSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          types: schedule.types.map(type => type._id === updatedSchedule._id ? updatedSchedule : type)
        }))
      }
      Alert.success(intl.formatMessage({ id: 'type.update-success' }));
      history.push("/types");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const editType = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.type.update_do"}));
    await putScheduleMutation({ collection: 'type',  _id:match.params.id , schedule:cleanObjectAndReturn(values) })
  }

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }



  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title={editForm ? "button.s.type-update":"button.s.type-create"} back backLink="/types" />
      <div className="pad-2rem">
        <Container fluid>
          <Row>
            <Col md={4}>
              <Formik
                validationSchema={
                  Yup.object().shape({
                    name: Yup.string().required(),
                    icon: Yup.string().required(),
                  })
                }
                initialValues={editForm
                  ? {
                    ...schedule.types.find(
                      r => r._id === match.params.id
                    )
                  }
                  : {
                    name: match.params.name ? match.params.name : '',
                    icon: ''
                  }}
                enableReinitialize={true}
                onSubmit={ async ({ name, icon }) => {
                  editForm ? 
                    editType({ name, icon })
                  : addType({ name, icon });
                }}
              >
                {({ values }) => {
                  return (
                    <Form className="floating-label-form">
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        name="name"
                        id="name"
                        placeholder={intl.formatMessage({
                          id: "input.name"
                        })}
                        label={intl.formatMessage({
                          id: "input.name"
                        })}
                        required
                      />
                      <Field
                        component={ImageUpload}
                        id="icon"
                        accept="image/*"
                        name="icon"
                        label={intl.formatMessage({
                          id: "button.uploadFile"
                        })}
                        placeholder={intl.formatMessage({
                          id: "button.uploadFile"
                        })}
                      />
                      <Button
                        type="submit"
                        variant="primary"
                      >
                        {editForm ? intl.formatMessage({ id: `button.s.type-update` }) : intl.formatMessage({ id: `button.s.type-create` })}
                      </Button>
                    </Form>
                  )
                }}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default injectIntl(TypeForm);
